module.exports = __webpack_public_path__ + "img/1280px-GMAT_Logo_Vector.f99625a1.png";